import { Film, Users, Mail, Archive } from "lucide-react";

const Stat = ({ icon: Icon, label, value }) => (
  <div className="border border-white/10 bg-[#121418] p-6">
    <Icon size={20} className="text-[#C5A059] mb-4" strokeWidth={1.5} />
    <p className="font-serif text-3xl text-[#EBE9E1]">{value}</p>
    <p className="text-[10px] tracking-widest uppercase text-[#8A8F98] mt-1">{label}</p>
  </div>
);

export const StatCards = ({ stats }) => {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
      <Stat icon={Film} label="Streamable" value={stats.streamable_videos ?? stats.total_videos} />
      <Stat icon={Archive} label="Archival (offline)" value={stats.archival_videos ?? 0} />
      <Stat icon={Users} label="Members" value={stats.total_users} />
      <Stat icon={Mail} label="Total Records" value={stats.total_videos} />
    </div>
  );
};
